/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seo-button',
  templateUrl: './seo-button.component.html',
  styleUrls: ['./seo-button.component.scss'],
})
export class SeoButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
